import React, {Component, useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../../../util/fonts';

import AppWrapper from '../../../../components/app-wrapper';
import {strings} from '../../../../util/strings';
import {addToGlobalStyles, addToWizard} from '../../../../store/actions';
import ModalTemplate from '../../../../components/modal/ModalTemplate';
import {Column, Row} from '../../../../components/layout';
import AppButton from '../../../../components/app-button';
import App from '../../../../App';
import colors from '../../../../util/colors';

interface RequestPopupPreAuthorizationProps {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.preAuthorizations;
  show: boolean;
  buStyles: any;
  setShowModal(value: any): void;
  addToWizard(value: any): void;
}

function RequestPopupPreAuthorization({
  user,
  addToGlobalStyles,
  selectedBu,
  labels,
  addToWizard,
  show,
  buStyles,
  setShowModal,
}: RequestPopupPreAuthorizationProps) {
  const history = useHistory();

  return (
    <div className="pre-autorizacoes-modal-content p-0">
      <ModalTemplate
        show={show}
        onHide={() => setShowModal(false)}
        cross={true}
        hideFooter={true}>
        <Column>
          <Row className="pre-autorizacoes-title-row">
            <p
              style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
              className="p-preautorizacoes-title">
              {labels?.authorization_requestOfPreAuthorization}
            </p>
          </Row>
          <Row>
            <span
              style={{
                ...fonts.MM,
                ...fonts.Medium,
                color: colors.black,
              }}
              className="p-preautorizacoes">
              {labels?.authorization_dontHaveTheDocumentsYet}
            </span>
          </Row>
          <Row>
            <AppButton
              className="pre-autorizacoes-buttons"
              variant="secondary"
              style={{...fonts.M, color: buStyles?.primaryColor || colors.blue}}
              onClick={() =>
                history.push('/pre-autorizacoes/procedimento-pre-autorizacao')
              }>
              {labels?.authorization_obtainDocuments}
            </AppButton>
          </Row>
          <Row>
            <span
              style={{
                ...fonts.MM,
                ...fonts.Medium,
                color: colors.black,
              }}
              className="p-preautorizacoes">
              {labels?.authorization_alreadyHaveTheDocuments}
            </span>
          </Row>
          <Row className="mb-5">
            <AppButton
              className="pre-autorizacoes-buttons"
              style={{...fonts.M, color: colors.white}}
              onClick={() =>
                history.push('/pre-autorizacoes/pedido-pre-autorizacao')
              }>
              {labels?.authorization_submitRequest}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  globalStyles,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.preAuthorizations,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(RequestPopupPreAuthorization)
);
